export const MOBILEPAY: IWalletNameConstants = { walletName: "MobilePay", walletDisplayName: "MobilePay" };
export const VIPPS: IWalletNameConstants = { walletName: "Vipps", walletDisplayName: "Vipps" };
export const APPLEPAY: IWalletNameConstants = { walletName: "ApplePay", walletDisplayName: "Apple Pay" };
export const GOOGLEPAY: IWalletNameConstants = { walletName: "GooglePay", walletDisplayName: "Google Pay" };

export interface IWalletNameConstants {
    walletName: string,
    walletDisplayName?: string
}